import { render, staticRenderFns } from "./TemplateCreateModal.vue?vue&type=template&id=efdccdc0&scoped=true"
import script from "./TemplateCreateModal.vue?vue&type=script&lang=js"
export * from "./TemplateCreateModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateCreateModal.vue?vue&type=style&index=0&id=efdccdc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdccdc0",
  null
  
)

export default component.exports